import React from 'react';
import { Link } from 'react-router-dom';
import './JobTable.css';

const JobTable = ({ title, icon, items, columnHeader, getCategoryHref }) => (
  <div className="job-table-card">
    <div className="job-table-header">
      <span className="job-table-icon">{icon}</span>
      <h2 className="job-table-title">{title}</h2>
    </div>
    <div className="job-table-divider" />

    <table className="job-table">
      <thead>
        <tr>
          <th>{columnHeader}</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, idx) => (
          <tr key={item.id} className={idx % 2 === 0 ? 'row-even' : ''}>
            <td className="job-table-name">
              {item.name}
              <span className="job-table-count">{item.count.toLocaleString()}</span>
            </td>
            <td className="job-table-action">
              <Link className="btn-table-view" to={getCategoryHref(item.id)}>
                VIEW
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default JobTable;
